import React, { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Background, Page, Subpage, Images, Content, Table, Breaker, Title } from "./style";
import Prefeitura from "../../../assets/Images/prefeitura.jpg";
import Fiec from "../../../assets/Images/fiec.png";
import PdfButtons from "../../../components/PdfButtons";

export default function PdfAtribuicaoAulaTotal() {
  const [atribuicoes, setAtribuicoes] = useState([]);
  const location = useLocation();
  const ref = useRef();

  useEffect(() => {
    if (location.state.atribuicoes) {
      setAtribuicoes(location.state.atribuicoes.sort((a, b) => b.total - a.total) || []);
    }
  }, [location?.state]);

  return (
    <Background>
      <PdfButtons />
      <Page>
        <Subpage>
          <Breaker ref={ref}>
            <Images>
              <img src={Fiec} alt="FIEC Logo" />
              <img src={Prefeitura} alt="Prefeitura Logo" />
            </Images>
            <Content>
              <Title>Carga Horária Total dos Colaboradores</Title>
              {atribuicoes?.length > 0 && (
                <Table>
                  <thead>
                    <tr>
                      <th>Matrícula</th>
                      <th>Nome</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {atribuicoes.map((a, i) => {
                      return (
                        <tr key={a.matricula}>
                          <td className="matricula" data-title="Matricula" value={a.matricula}>
                            {a.matricula}
                          </td>
                          <td className="nome" data-title="Nome" value={a.nome} title={a.nome}>
                            {a.nome}
                          </td>
                          <td className="total" data-title="Total" value={a.total} title={a.total}>
                            {a.total}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </Content>
          </Breaker>
        </Subpage>
      </Page>
    </Background>
  );
}
